import { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { Input, Button, Table, Space, } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectProductType } from "../../component/common/Selects"
import { DeleteButton } from "../../component/common/Buttons"
import { CheckImgs } from "../../component/common/Imgs"
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    goods_type_id: string | undefined
    goods_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        goods_type_id: undefined,
        goods_name: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/mall_center/sku/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 商品管理 -> 商品规格管理 */}
        <BreadCrumb position={['商城中心', '商品规格管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 5, marginBottom: 12 }}>
                    <SelectProductType value={fetchOtherParams.goods_type_id} onChange={(v: string) => { handleChange(v, 'goods_type_id') }} />
                </div>
                <Input style={{ width: '180px', marginRight: 5, marginBottom: 12 }} placeholder="商品名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'goods_name') }} value={fetchOtherParams.goods_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to="/product_specs_add">添加</Link></Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="商品编号" dataIndex="goods_code" key="goods_code" />
                <Column title="商品名称" dataIndex="goods_name" key="goods_name" />
                <Column title="商品分类" dataIndex="goods_type_name" key="goods_type_name" />
                <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                <Column title="规格名称" dataIndex="goods_specs_values" key="goods_specs_values" />
                <Column title="规格编号" dataIndex="sku_code" key="sku_code" />
                <Column title="规格图片" dataIndex="sku_pic_url" key="sku_pic_url" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls([v])
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="规格库存" dataIndex="inventory_num" key="inventory_num" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Link to={"/product_specs_edit/" + record.id}>编辑</Link>
                            <DeleteButton record={record} url="/mall_center/sku/delete" cb={resetForm} />
                        </Space>
                    )}
                />
            </Table>
        </div>

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>)
}